export const voidPromise = (): Promise<void> => Promise.resolve();

export const voidFunction = (): void => {
    return;
};
